export const underConstructionContent = {
    en: {
      title: "Page under construction!",
      text: "This page is currently under construction.",
      home: "Back to homepage",
      hint: "We are still building/renovating this page for Revimo, we hope that it will be available soon. Thank you for your understanding.",
    },
    sl: {
        title: "Stran v razvoju!",
        text: "Ta stran je trenutno v razvoju in še ni dokončana.",
        home: "Nazaj na domačo stran",
        hint: "Delamo vse, da jo popravimo/dokončamo v najkrajšem možnem času. Hvala za razumevanje.",
    },

} as const;